import script from "./FooterBar.vue?vue&type=script&lang=ts&setup=true"
export * from "./FooterBar.vue?vue&type=script&lang=ts&setup=true"

import "./FooterBar.vue?vue&type=style&index=0&id=52f098b4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52f098b4"]])

export default __exports__